import React, { useState } from "react"
import {
  Row,
  Col,
  CardBody,
  Card,
  Container,
  Form,
  Input,
  Label,
} from "reactstrap"
import { Link, useNavigate } from "react-router-dom"

import profile from "assets/images/logo_transparent.png"
import logo from "assets/images/logo.svg"

import "../../assets/css/Login/Login.css"
import Configs from "../../config"
import { FetchPutData } from "utils/Common_api_functions"
import Swal from "sweetalert2"
import Loader from "components/Loader/loader"
import { IoMdEye, IoMdEyeOff } from "react-icons/io"
import secureLocalStorage from "react-secure-storage"

const ResetPassword = () => {
  const navigate = useNavigate()

  document.title = "Reset Password | J. Kyle Cleaning Services"

  const [loading, setLoading] = useState(false)
  const [formData, setFormData] = useState({
    newPassword: "",
    confirmPassword: "",
  })
  const [errors, setErrors] = useState({})
  const [showNewPassword, setShowNewPassword] = useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = useState(false)

  const toggleNewPassword = () => setShowNewPassword(prev => !prev)
  const toggleConfirmPassword = () => setShowConfirmPassword(prev => !prev)

  const handleChange = e => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))
    setErrors(prev => ({ ...prev, [name]: "" }))
  }

  const validate = () => {
    const errs = {}

    if (!formData.newPassword) {
      errs.newPassword = "New password is required"
    } else if (formData.newPassword.length < 6) {
      errs.newPassword = "Password must be at least 6 characters"
    }

    if (!formData.confirmPassword) {
      errs.confirmPassword = "Please confirm your password"
    } else if (formData.newPassword !== formData.confirmPassword) {
      errs.confirmPassword = "Passwords do not match"
    }

    setErrors(errs)
    return Object.keys(errs).length === 0
  }

  const authCod = secureLocalStorage.getItem("authCod")

  const handleSubmit = async e => {
    e.preventDefault()
    if (!validate()) return

    if (!authCod.id || !authCod.email) {
      return
    }

    setLoading(true)

    try {
      const endpoint = authCod?.userType === "supplier"
        ? "supplier/update/password"
        : "employee/update/password";

      const APIData = await FetchPutData(
        setLoading,
        endpoint,
        authCod?.id,
        {
          password: formData.newPassword,
        }
      )

      if (APIData?.data?.success) {
        Swal.fire({
          title: "Success!",
          text:
            APIData?.data?.message ||
            "Your password has been reset successfully.",
          icon: "success",
          timer: 2000,
          timerProgressBar: true,
        })

        setTimeout(() => {
          navigate("/login")
        }, 2200)
      } else {
        Swal.fire({
          title: "Failed",
          text:
            APIData?.response?.data?.message ||
            "Could not reset password. Please try again.",
          icon: "error",
        })
      }
    } catch (err) {
      Swal.fire({
        title: "Error",
        text: "Something went wrong. Please try again later.",
        icon: "error",
      })
    } finally {
      setLoading(false)
    }
  }

  return (
    <React.Fragment>
      {loading && <Loader />}

      <div className="login-page">
        <div className="account-pages">
          <Container>
            <Row className="justify-content-end">
              <Col md={8} lg={6} xl={5}>
                <Card className="overflow-hidden">
                  <div className="bg-darkblue pe-3">
                    <Row>
                      <Col xs={6}>
                        <div className="text-black p-4 pe-0">
                          <h5 className="text-white fw-bold">
                            Set New Password
                          </h5>
                          <p className="text-white">
                            Your new password must be strong <br />
                          </p>
                        </div>
                      </Col>
                      <Col className="col-6 align-self-center">
                        <div className="bg-white p-2">
                          <img
                            src={profile}
                            alt="Reset Password"
                            className="img-fluid"
                          />
                        </div>
                      </Col>
                    </Row>
                  </div>

                  <CardBody className="pt-0">
                    <div className="text-center">
                      <Link
                        to={`${Configs.appurl}`}
                        className="logo-light-element"
                      >
                        <div className="avatar-md profile-user-wid mb-4">
                          <span className="avatar-title rounded-circle bg-light">
                            <img src={logo} alt="Logo" height="34" />
                          </span>
                        </div>
                      </Link>
                    </div>

                    <div className="p-2">
                      <Form onSubmit={handleSubmit}>
                        {/* New Password */}
                        <div className="mb-3 position-relative">
                          <Label className="form-label">
                            New Password <span className="text-danger">*</span>
                          </Label>
                          <div className="input-group">
                            <Input
                              name="newPassword"
                              type={showNewPassword ? "text" : "password"}
                              placeholder="Enter new password"
                              value={formData.newPassword}
                              onChange={handleChange}
                              style={{
                                borderRadius: "10px",
                                paddingRight: "45px",
                              }}
                            />
                            <span
                              onClick={toggleNewPassword}
                              style={{
                                position: "absolute",
                                right: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                zIndex: 10,
                                color: "#6c757d",
                              }}
                            >
                              {showNewPassword ? (
                                <IoMdEye size={18} />
                              ) : (
                                <IoMdEyeOff size={18} />
                              )}
                            </span>
                          </div>
                          {errors.newPassword && (
                            <span className="text-danger">
                              {errors.newPassword}
                            </span>
                          )}
                        </div>

                        {/* Confirm Password */}
                        <div className="mb-3 position-relative">
                          <Label className="form-label">
                            Confirm Password{" "}
                            <span className="text-danger">*</span>
                          </Label>
                          <div className="input-group">
                            <Input
                              name="confirmPassword"
                              type={showConfirmPassword ? "text" : "password"}
                              placeholder="Confirm new password"
                              value={formData.confirmPassword}
                              onChange={handleChange}
                              style={{
                                borderRadius: "10px",
                                paddingRight: "45px",
                              }}
                            />
                            <span
                              onClick={toggleConfirmPassword}
                              style={{
                                position: "absolute",
                                right: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                cursor: "pointer",
                                zIndex: 10,
                                color: "#6c757d",
                              }}
                            >
                              {showConfirmPassword ? (
                                <IoMdEye size={18} />
                              ) : (
                                <IoMdEyeOff size={18} />
                              )}
                            </span>
                          </div>
                          {errors.confirmPassword && (
                            <span className="text-danger">
                              {errors.confirmPassword}
                            </span>
                          )}
                        </div>

                        <div className="mt-4 d-grid">
                          <button
                            type="submit"
                            className="btn btn-blue text-white btn-block"
                            disabled={loading}
                          >
                            {loading ? "Resetting..." : "Reset Password"}
                          </button>
                        </div>

                        <div className="mt-4 text-center">
                          <Link to="/login" className="text-muted">
                            Back to Login
                          </Link>
                        </div>
                      </Form>
                    </div>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </div>
    </React.Fragment>
  )
}

export default ResetPassword
